// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.comman-gradient-header h1 {
  font-size: var(--font-size-xxxxlarge);
  font-weight: var(--font-bold);
  font-family: var(--font-codec-cold);
  line-height: 45px;
  color: var(--text-primary);
}

.comman-gradient-header h3 {
  font-size: var(--font-size-xxlarge);
  font-weight: var(--font-semibold);
  color: var(--text-black-light-2);
  margin-top: 20px;
}

.comman-gradient-header p {
  font-size: var(--font-size-medium);
  font-weight: var(--font-medium);
  color: var(--bg-black);
  margin: 0 auto;
  text-align: center;
  margin-top: 25px;
  line-height: 25px;
}

.pricing-details-content {
  padding: 20px 0;
}

.details-1 {
  font-size: var(--font-size-large);
  font-weight: var(--font-medium);
  color: var(--text-black);
}

.details-1 span,
.details-2 span {
  font-weight: var(--font-bold);
}

.details-2 {
  font-size: var(--font-size-medium);
  font-weight: var(--font-medium);
  color: var(--text-black);
}

.details-3 {
  font-size: var(--font-size-large);
  font-weight: var(--font-semibold);
  color: var(--text-black);
}

.pricing-details-content ul {
  padding: 20px 0;
}

.pricing-details-content ul li {
  font-size: var(--font-size-xlarge);
  font-weight: var(--font-semibold);
  color: var(--text-black-light-3);
  line-height: 1.66;
}


.pricing-card {
  background: #FFFFFF;
  padding: 30px 20px 15px 20px;
  text-align: center;
  height: 100%;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
  border-radius: 12px;
  border: 2px solid transparent;
  background-clip: padding-box;
  isolation: isolate;
}

.pricing-card::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 12px;
  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
  z-index: -2;
  pointer-events: none;
}

.pricing-card::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 12px;
  background: #FFFFFF;
  z-index: -1;
  pointer-events: none;
}

.pricing-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.pricing-card:hover::before {
  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
  z-index: -2;
}

.pricing-card:hover::after {
  background: #FFFFFF;
  z-index: -1;
}

.pricing-card-title {
  font-family: var(--font-codec-cold);
  font-size: var(--font-size-regular);
  font-weight: var(--font-bold);
  color: var(--text-primary);
}

.pricing-card-description {
  font-size: var(--font-size-small);
  font-weight: var(--font-medium);
  color: var(--text-gray-dark);
  margin-top: 15px;
}

.ct-details p a {
  font-size: var(--font-size-lg);
  font-weight: var(--font-medium);
  color: var(--text-black-light-4);
  text-decoration: none;
}

.ct-details p {
  margin-bottom: 0;
}


.pricing-card-2 {
  background: #FFFFFF;
  padding: 35px 130px 30px 130px;
  text-align: center;
  height: 100%;
  position: relative;
  background-clip: padding-box;
  transition: all 0.3s ease;
  border-radius: 12px;
  border: 2px solid transparent;
  isolation: isolate;
}

.pricing-card-2::before {
  content: '';
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  border-radius: 12px;
  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
  z-index: -2;
  pointer-events: none;
}

.pricing-card-2::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 12px;
  background: #FFFFFF;
  z-index: -1;
  pointer-events: none;
}

.pricing-card-2:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
}

.pricing-card-2:hover::before {
  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
  z-index: -2;
}

.pricing-card-2:hover::after {
  background: #FFFFFF;
  z-index: -1;
}

.large-card {
  padding: 80px 0 50px 0;
}

.pricing-card-2-heading {
  font-family: var(--font-codec-cold);
  font-size: var(--font-size-xxxlarge);
  font-weight: var(--font-bold);
  color: var(--text-black);
}

.pricing-card-2-title {
  font-size: var(--font-size-large);
  font-weight: var(--font-semibold);
  color: var(--text-black);
}

.pricing-card-2-subtitle {
  font-family: var(--font-codec-cold);
  font-size: var(--font-size-large);
  font-weight: var(--font-bold);
  color: var(--text-black);
}

.pricing-card-2-heading {
  margin-bottom: 25px;
}

@media (min-width: 768px) and (max-width: 1024px) {
  .pricing-card-title {
    font-size: var(--font-size-regular);
  }

  .pricing-details-content ul li {
    font-size: 22px;
  }

  .pricing-card-description {
    font-size: var(--font-size-xsmall);
  }

}

@media (max-width: 767px) {
  .pricing-card-title {
    font-size: var(--font-size-xsmall);
  }

  .pricing-card-description {
    font-size: var(--font-size-small);
    margin-top: 10px;
  }

  .comman-gradient-header h1 {
    font-size: var(--font-size-large);
    line-height: 1.5;
  }

  .comman-gradient-header {
    padding: 123px 20px 49px 20px;
  }

  .comman-gradient-header h3 {
    font-size: var(--font-size-regular);
  }

  .comman-gradient-header p {
    font-size: var(--font-size-small);
  }

  .details-1 {
    font-size: var(--font-size-xsmall);
  }

  .details-2 {
    font-size: var(--font-size-small);
  }

  .details-3 {
    font-size: var(--font-size-xsmall);
  }

  .pricing-details-content {
    padding: 20px 10px;
  }

  .pricing-details-content ul li {
    font-size: var(--font-size-xsmall);
    text-indent: -36px;
  }

  .pricing-details-content ul {
    padding: 20px 20px 0 35px;
  }

  .ct-details p a {
    font-size: var(--font-size-medium);
  }

  .ct-details img {
    width: 50px;
  }

  .large-card {
    padding: 40px 0 15px 0;
  }

  .pricing-card-2 {
    background: #FFFFFF;
    padding: 35px 20px 30px 20px;
  }
  
  .pricing-card::before {
    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
    z-index: -2;
  }
  
  .pricing-card::after {
    background: #FFFFFF;
    z-index: -1;
  }
  
  .pricing-card-2::before {
    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
    z-index: -2;
  }
  
  .pricing-card-2::after {
    background: #FFFFFF;
    z-index: -1;
  }

  .pricing-card-2-heading {
    font-size: var(--font-size-large);
  }

  .pricing-card-2-title,
  .pricing-card-2-subtitle {
    font-size: var(--font-size-xsmall);
  }

  .pricing-card-2-heading span {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .pricing-card-2-heading span img {
    width: 20px;
  }
}

@media (min-width: 1025px) and (max-width: 1280px) {
  .comman-gradient-header h1 {
    font-size: var(--font-size-xxxlarge) !important;
  }

  .comman-gradient-header h3 {
    font-size: var(--font-size-xlarge) !important;
  }

  .comman-gradient-header p {
    font-size: var(--font-size-18) !important;
    padding: 0 120px;
  }

  .pricing-card-description {
    font-size: 13px !important;
    ;
    margin-top: 8px !important;
  }

  .pricing-details-content ul li {
    font-size: var(--font-size-25) !important;
  }

  .details-2 {
    font-size: var(--font-size-18) !important;
  }

  .details-1 {
    font-size: var(--font-size-medium) !important;
  }

  .pricing-card-2-title {
    font-size: var(--font-size-medium) !important;
  }

  .pricing-card-2-subtitle {
    font-size: var(--font-size-medium) !important;
    font-family: var(--font-codec-cold-extra-bold) !important;
  }

  .pricing-card-2-heading {
    font-family: var(--font-codec-cold-extra-bold) !important;
  }

  .pricing-card-2 {
    padding: 35px 75px 30px 75px;
  }
  
  .pricing-card::before {
    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
    z-index: -2;
  }
  
  .pricing-card::after {
    background: #FFFFFF;
    z-index: -1;
  }
  
  .pricing-card-2::before {
    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);
    z-index: -2;
  }
  
  .pricing-card-2::after {
    background: #FFFFFF;
    z-index: -1;
  }

  .pricing-card-title {
    font-size: var(--font-size-18);
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Website/PricingPage/PricingPage.css"],"names":[],"mappings":"AAAA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,mCAAmC;EACnC,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,gCAAgC;EAChC,iBAAiB;AACnB;;;AAGA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uFAAuF;EACvF,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,uFAAuF;EACvF,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,iCAAiC;EACjC,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uFAAuF;EACvF,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,uFAAuF;EACvF,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,wBAAwB;AAC1B;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,mCAAmC;EACrC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kCAAkC;EACpC;;AAEF;;AAEA;EACE;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;IACjC,gBAAgB;EAClB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kCAAkC;IAClC,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,4BAA4B;EAC9B;;EAEA;IACE,uFAAuF;IACvF,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,uFAAuF;IACvF,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,iCAAiC;EACnC;;EAEA;;IAEE,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,+CAA+C;EACjD;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,yCAAyC;IACzC,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;;IAE1B,0BAA0B;EAC5B;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,6CAA6C;IAC7C,yDAAyD;EAC3D;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,uFAAuF;IACvF,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,uFAAuF;IACvF,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,8BAA8B;EAChC;;AAEF","sourcesContent":[".comman-gradient-header h1 {\n  font-size: var(--font-size-xxxxlarge);\n  font-weight: var(--font-bold);\n  font-family: var(--font-codec-cold);\n  line-height: 45px;\n  color: var(--text-primary);\n}\n\n.comman-gradient-header h3 {\n  font-size: var(--font-size-xxlarge);\n  font-weight: var(--font-semibold);\n  color: var(--text-black-light-2);\n  margin-top: 20px;\n}\n\n.comman-gradient-header p {\n  font-size: var(--font-size-medium);\n  font-weight: var(--font-medium);\n  color: var(--bg-black);\n  margin: 0 auto;\n  text-align: center;\n  margin-top: 25px;\n  line-height: 25px;\n}\n\n.pricing-details-content {\n  padding: 20px 0;\n}\n\n.details-1 {\n  font-size: var(--font-size-large);\n  font-weight: var(--font-medium);\n  color: var(--text-black);\n}\n\n.details-1 span,\n.details-2 span {\n  font-weight: var(--font-bold);\n}\n\n.details-2 {\n  font-size: var(--font-size-medium);\n  font-weight: var(--font-medium);\n  color: var(--text-black);\n}\n\n.details-3 {\n  font-size: var(--font-size-large);\n  font-weight: var(--font-semibold);\n  color: var(--text-black);\n}\n\n.pricing-details-content ul {\n  padding: 20px 0;\n}\n\n.pricing-details-content ul li {\n  font-size: var(--font-size-xlarge);\n  font-weight: var(--font-semibold);\n  color: var(--text-black-light-3);\n  line-height: 1.66;\n}\n\n\n.pricing-card {\n  background: #FFFFFF;\n  padding: 30px 20px 15px 20px;\n  text-align: center;\n  height: 100%;\n  position: relative;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  transition: all 0.3s ease;\n  border-radius: 12px;\n  border: 2px solid transparent;\n  background-clip: padding-box;\n  isolation: isolate;\n}\n\n.pricing-card::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n  z-index: -2;\n  pointer-events: none;\n}\n\n.pricing-card::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 12px;\n  background: #FFFFFF;\n  z-index: -1;\n  pointer-events: none;\n}\n\n.pricing-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n}\n\n.pricing-card:hover::before {\n  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n  z-index: -2;\n}\n\n.pricing-card:hover::after {\n  background: #FFFFFF;\n  z-index: -1;\n}\n\n.pricing-card-title {\n  font-family: var(--font-codec-cold);\n  font-size: var(--font-size-regular);\n  font-weight: var(--font-bold);\n  color: var(--text-primary);\n}\n\n.pricing-card-description {\n  font-size: var(--font-size-small);\n  font-weight: var(--font-medium);\n  color: var(--text-gray-dark);\n  margin-top: 15px;\n}\n\n.ct-details p a {\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-medium);\n  color: var(--text-black-light-4);\n  text-decoration: none;\n}\n\n.ct-details p {\n  margin-bottom: 0;\n}\n\n\n.pricing-card-2 {\n  background: #FFFFFF;\n  padding: 35px 130px 30px 130px;\n  text-align: center;\n  height: 100%;\n  position: relative;\n  background-clip: padding-box;\n  transition: all 0.3s ease;\n  border-radius: 12px;\n  border: 2px solid transparent;\n  isolation: isolate;\n}\n\n.pricing-card-2::before {\n  content: '';\n  position: absolute;\n  top: -2px;\n  left: -2px;\n  right: -2px;\n  bottom: -2px;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n  z-index: -2;\n  pointer-events: none;\n}\n\n.pricing-card-2::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  border-radius: 12px;\n  background: #FFFFFF;\n  z-index: -1;\n  pointer-events: none;\n}\n\n.pricing-card-2:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);\n}\n\n.pricing-card-2:hover::before {\n  background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n  z-index: -2;\n}\n\n.pricing-card-2:hover::after {\n  background: #FFFFFF;\n  z-index: -1;\n}\n\n.large-card {\n  padding: 80px 0 50px 0;\n}\n\n.pricing-card-2-heading {\n  font-family: var(--font-codec-cold);\n  font-size: var(--font-size-xxxlarge);\n  font-weight: var(--font-bold);\n  color: var(--text-black);\n}\n\n.pricing-card-2-title {\n  font-size: var(--font-size-large);\n  font-weight: var(--font-semibold);\n  color: var(--text-black);\n}\n\n.pricing-card-2-subtitle {\n  font-family: var(--font-codec-cold);\n  font-size: var(--font-size-large);\n  font-weight: var(--font-bold);\n  color: var(--text-black);\n}\n\n.pricing-card-2-heading {\n  margin-bottom: 25px;\n}\n\n@media (min-width: 768px) and (max-width: 1024px) {\n  .pricing-card-title {\n    font-size: var(--font-size-regular);\n  }\n\n  .pricing-details-content ul li {\n    font-size: 22px;\n  }\n\n  .pricing-card-description {\n    font-size: var(--font-size-xsmall);\n  }\n\n}\n\n@media (max-width: 767px) {\n  .pricing-card-title {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .pricing-card-description {\n    font-size: var(--font-size-small);\n    margin-top: 10px;\n  }\n\n  .comman-gradient-header h1 {\n    font-size: var(--font-size-large);\n    line-height: 1.5;\n  }\n\n  .comman-gradient-header {\n    padding: 123px 20px 49px 20px;\n  }\n\n  .comman-gradient-header h3 {\n    font-size: var(--font-size-regular);\n  }\n\n  .comman-gradient-header p {\n    font-size: var(--font-size-small);\n  }\n\n  .details-1 {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .details-2 {\n    font-size: var(--font-size-small);\n  }\n\n  .details-3 {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .pricing-details-content {\n    padding: 20px 10px;\n  }\n\n  .pricing-details-content ul li {\n    font-size: var(--font-size-xsmall);\n    text-indent: -36px;\n  }\n\n  .pricing-details-content ul {\n    padding: 20px 20px 0 35px;\n  }\n\n  .ct-details p a {\n    font-size: var(--font-size-medium);\n  }\n\n  .ct-details img {\n    width: 50px;\n  }\n\n  .large-card {\n    padding: 40px 0 15px 0;\n  }\n\n  .pricing-card-2 {\n    background: #FFFFFF;\n    padding: 35px 20px 30px 20px;\n  }\n  \n  .pricing-card::before {\n    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n    z-index: -2;\n  }\n  \n  .pricing-card::after {\n    background: #FFFFFF;\n    z-index: -1;\n  }\n  \n  .pricing-card-2::before {\n    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n    z-index: -2;\n  }\n  \n  .pricing-card-2::after {\n    background: #FFFFFF;\n    z-index: -1;\n  }\n\n  .pricing-card-2-heading {\n    font-size: var(--font-size-large);\n  }\n\n  .pricing-card-2-title,\n  .pricing-card-2-subtitle {\n    font-size: var(--font-size-xsmall);\n  }\n\n  .pricing-card-2-heading span {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  .pricing-card-2-heading span img {\n    width: 20px;\n  }\n}\n\n@media (min-width: 1025px) and (max-width: 1280px) {\n  .comman-gradient-header h1 {\n    font-size: var(--font-size-xxxlarge) !important;\n  }\n\n  .comman-gradient-header h3 {\n    font-size: var(--font-size-xlarge) !important;\n  }\n\n  .comman-gradient-header p {\n    font-size: var(--font-size-18) !important;\n    padding: 0 120px;\n  }\n\n  .pricing-card-description {\n    font-size: 13px !important;\n    ;\n    margin-top: 8px !important;\n  }\n\n  .pricing-details-content ul li {\n    font-size: var(--font-size-25) !important;\n  }\n\n  .details-2 {\n    font-size: var(--font-size-18) !important;\n  }\n\n  .details-1 {\n    font-size: var(--font-size-medium) !important;\n  }\n\n  .pricing-card-2-title {\n    font-size: var(--font-size-medium) !important;\n  }\n\n  .pricing-card-2-subtitle {\n    font-size: var(--font-size-medium) !important;\n    font-family: var(--font-codec-cold-extra-bold) !important;\n  }\n\n  .pricing-card-2-heading {\n    font-family: var(--font-codec-cold-extra-bold) !important;\n  }\n\n  .pricing-card-2 {\n    padding: 35px 75px 30px 75px;\n  }\n  \n  .pricing-card::before {\n    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n    z-index: -2;\n  }\n  \n  .pricing-card::after {\n    background: #FFFFFF;\n    z-index: -1;\n  }\n  \n  .pricing-card-2::before {\n    background: linear-gradient(135deg, #FFD700 0%, #FFD700 25%, #8B5CF6 75%, #8B5CF6 100%);\n    z-index: -2;\n  }\n  \n  .pricing-card-2::after {\n    background: #FFFFFF;\n    z-index: -1;\n  }\n\n  .pricing-card-title {\n    font-size: var(--font-size-18);\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
